import {
  SET, WORKSHOP_BSX_AUTH_UPDATE,
  WORKSHOP_CALENDAR_ADD,
  WORKSHOP_CALENDAR_DELETE,
  WORKSHOP_CALENDAR_UPDATE,
  WORKSHOP_CASH_BOX_ADD,
  WORKSHOP_CASH_BOX_DELETE,
  WORKSHOP_CASH_BOX_UPDATE,
  WORKSHOP_INTEGRATION_UPDATE,
  WORKSHOP_PLAN_SMS_AVAILABLE_COUNT_SET,
  WORKSHOP_PLAN_UPDATE,
  WORKSHOP_PRODUCT_PRICE_GROUP_ADD,
  WORKSHOP_PRODUCT_PRICE_GROUP_UPDATE,
  WORKSHOP_WORKSHOP_PLAN_VEHICLE_BY_REG_NUMBER_COUNT_UPDATE,
} from './actions';

const initialState = {};
export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET:
      return action.value;

    case WORKSHOP_PLAN_UPDATE: {
      return {
        ...state,
        workshopPlan: action.workshopPlan,
      }
    }

    case WORKSHOP_PRODUCT_PRICE_GROUP_ADD: {
      state.workshopProductPriceGroups.push(action.workshopProductPriceGroup);
      return state
    }

    case WORKSHOP_PRODUCT_PRICE_GROUP_UPDATE: {
      return {
        ...state,
        workshopProductPriceGroups: state.workshopProductPriceGroups.map(workshopProductPriceGroup => {
          if (workshopProductPriceGroup.id === action.workshopProductPriceGroup.id) {
            return action.workshopProductPriceGroup;
          }

          return workshopProductPriceGroup;
        })
      }
    }

    case WORKSHOP_CALENDAR_ADD: {
      state.calendars.push(action.calendar);
      return state
    }

    case WORKSHOP_CALENDAR_UPDATE: {
      return {
        ...state,
        calendars: state.calendars.map(calendar => {
          if (calendar.id === action.calendar.id) {
            return action.calendar;
          }

          return calendar;
        })
      }
    }

    case WORKSHOP_CALENDAR_DELETE: {
      return {
        ...state,
        calendars: state.calendars.filter(calendar => calendar.id !== action.calendarId)
      }
    }

    case WORKSHOP_CASH_BOX_ADD: {
      state.cashBoxes.push(action.cashBox);
      return state
    }

    case WORKSHOP_CASH_BOX_UPDATE: {
      return {
        ...state,
        cashBoxes: state.cashBoxes.map(cashBox => {
          if (cashBox.id === action.cashBox.id) {
            return action.cashBox;
          }

          return cashBox;
        })
      }
    }

    case WORKSHOP_CASH_BOX_DELETE: {
      return {
        ...state,
        cashBoxes: state.cashBoxes.filter(cashBox => cashBox.id !== action.cashBoxId)
      }
    }

    case WORKSHOP_PLAN_SMS_AVAILABLE_COUNT_SET: {
      if(state.workshopPlan.smsAvailableCount !== action.smsAvailableCount){
        return {
          ...state,
          workshopPlan: {
            ...state.workshopPlan,
            smsAvailableCount: action.smsAvailableCount,
          }
        }
      }

      return state;
    }

    case WORKSHOP_WORKSHOP_PLAN_VEHICLE_BY_REG_NUMBER_COUNT_UPDATE: {
      return {
        ...state,
        workshopPlan: {
          ...state.workshopPlan,
          vehicleByRegNumberCount: action.vehicleByRegNumberCount,
        }
      }
    }

    case WORKSHOP_INTEGRATION_UPDATE: {
      return {
        ...state,
        integration: {
          ...state.integration,
          ...action.integration,
        }
      }
    }

    case WORKSHOP_BSX_AUTH_UPDATE: {
      return {
        ...state,
        bsxPrinterAuths: action.bsxPrinterAuths,
      };
    }

    default:
      return state;
  }
};
